export const COLORS = {
  beach: 'Beach',
  coraline: 'Coraline',
  'coraline-dark': 'Coraline Dark',
  mint: 'Mint',
  'mint-dark': 'Mint Dark',
  punk: 'Punk',
  'punk-dark': 'Punk Dark',
  'peppa-pig': 'Peppa Pig',
  sun: 'Sun',
  eggplant: 'Eggplant',
  'dark-nest': 'Dark Nest'
}

export const DEPRECATED_COLORS = {
  roman: 'Roman',
  'brick-red': 'Brick Red',
  broom: 'Broom',
  parsley: 'Parsley',
  'silver-tree': 'Silver Tree',
  calypso: 'Calypso',
  cerise: 'Cerise',
  atlantis: 'Atlantis',
  'neutral-0': 'Neutral Dark',
  'neutral-95': 'Neutral Light'
}

export const TEXT_COLORS = {
  roman: 'primary-inverse',
  'brick-red': 'primary-inverse',
  broom: 'primary',
  parsley: 'primary-inverse',
  'silver-tree': 'primary',
  calypso: 'primary-inverse',
  cerise: 'primary-inverse',
  atlantis: 'primary',
  'neutral-0': 'primary-inverse',
  'neutral-95': 'primary',
  beach: 'primary',
  coraline: 'primary-inverse',
  'coraline-dark': 'primary-inverse',
  mint: 'primary',
  'mint-dark': 'primary-inverse',
  punk: 'primary-inverse',
  'punk-dark': 'primary-inverse',
  'peppa-pig': 'primary-inverse',
  sun: 'primary',
  eggplant: 'primary-inverse',
  'dark-nest': 'primary-inverse'
}
export default {
  data() {
    return {
      colorsList: COLORS
    }
  },
  methods: {
    getColorStyles(property, value) {
      if (!value) return
      if (
        value.startsWith('rgb') ||
        value.startsWith('#' || value === 'inherit' || value === 'initial')
      ) {
        return `${property}: ${value};`
      } else if (value.startsWith('color-')) {
        return `${property}: var(--${value});`
      } else return `${property}: var(--color-${value});`
    },
    getTextColorForBackground(value) {
      return TEXT_COLORS[value] || 'primary-inverse'
    }
  }
}
